package com.example.mystybag.sharedmodels.project.responseModels

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable


@Serializable
class EmbeddingsDeltaResponse (
    val modelId     : String = "",
    val dim         : Int = 0,
    val items       : List<EmbeddingDeltaItem> = listOf()
): BaseResponseModel()

@Serializable
data class EmbeddingDeltaItem(
    val merchantLocationId: Long,
    val cityId: Long,
    val lang: String,
    val qScale: Float,
    val qZeroPoint: Int,
    val docType: String,
    val vecQint8: ByteArray // 384 bytes
)
